export function createSalesOrderFormInitialValues() {
  return {
    customerId: '',
    branch: '',
    seaweedType: '',
    quantity: '',
    dealPrice: '',
    sourcePurchaseOrderId: '',
    fclBatchNumber: '',
    codeNumber: '',
    containerNumber: '',
    soDate: getLocalDateInputValue(),
    warehouseLocation: '',
  };
}

function getLocalDateInputValue() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
